<script setup lang="ts">
import type { EditorialFashionShowProps } from './EditorialFashionShow.props'
const props = defineProps<EditorialFashionShowProps>()

const { ts } = useI18n()

const { openDialog } = useDialog('galleryFashionShow')

const selectedView = ref(props.defaultView ?? 'carousel')
const selectedMediaIndex = ref(0)

const changeSelectedView = (type: 'carousel' | 'grid') => {
  selectedView.value = type
}

const handleClickOnMedia = (index: number) => {
  selectedMediaIndex.value = index
  openDialog()
}
</script>

<template>
  <div
    class="editorial-fashion-show text-text-primary bg-background-secondary relative flex flex-col py-2 md:py-6 lg:py-16"
  >
    <div class="flex flex-col gap-6 py-6 md:gap-8 md:py-8 lg:gap-10 lg:py-10">
      <div class="relative text-center">
        <UtilsMarkdown
          v-if="title"
          :content="title"
          is-preprocessed
          container="span"
          class="!text-book-4 !lg:text-book-3 text-text-primary"
        />
      </div>
      <div v-if="showChangeView" class="flex justify-center gap-8">
        <button :aria-label="ts('aria-labels.gridThree')">
          <DefaultIconsGridThree
            class="h-5 w-5"
            :class="
              selectedView === 'carousel' ? 'viewSelected' : 'viewUnselected'
            "
            aria-hidden="true"
            @click="changeSelectedView('carousel')"
          />
        </button>
        <button :aria-label="ts('aria-labels.gridWall')">
          <DefaultIconsGridWall
            class="h-5 w-5"
            :class="selectedView === 'grid' ? 'viewSelected' : 'viewUnselected'"
            aria-hidden="true"
            @click="changeSelectedView('grid')"
          />
        </button>
      </div>
    </div>

    <div v-if="selectedView === 'carousel'">
      <EditorialFashionShowSlider
        :cards="cards"
        @clicked-media="handleClickOnMedia"
      />
    </div>
    <div v-else>
      <EditorialFashionShowGrid
        :cards="cards"
        @clicked-media="handleClickOnMedia"
      />
    </div>
  </div>
  <EditorialFashionShowModal
    :selected-media-index="selectedMediaIndex"
    :cards="cards"
  />
</template>

<style scoped lang="scss">
.viewSelected {
  @apply text-text-primary;
}

.viewUnselected {
  @apply text-text-inactive;
}
</style>
